import { Suspense, lazy } from "react";
import Meta from "../components/common/Helmet";
import i18n from "../translation/i18n";
import { useTranslation } from 'react-i18next';
// import LanguageSwitcher from "../components/common/LanguageSwitcher";
import Service from "../components/sections/Service";
import Product from "../components/sections/Product";
import Contact from "../components/sections/Contact";
import Portfolio from "../components/sections/Portfolio";
import SlideUp from "../components/ui/SlideUp";
import ClientsSection from "../components/sections/ClientsSection";
import GetStartedBox from "../components/sections/GetStartedBox";
import Testimonial from "../components/sections/Testimonial";
// import HomeSlider from "../components/sections/HomeSlider";
import AboutSection from "../components/sections/AboutSection";
import TechStack from "../components/sections/TechStack";
// import Header from "../components/ui/Header";
import settings from "../constants/settings";
import { homeMeta } from "../constants/meta";
import Loading from "../components/common/Loading";

const ClassicSlider = lazy(() => import("../components/sections/ClassicSlider"));

const Home = () => {
  const { t } = useTranslation();
  return (
    <div className="">
      <Meta
        title={homeMeta.title}
        description={homeMeta.description}
        canonical={homeMeta.canonical}
        keywords={homeMeta.keywords}
        googleSiteVerification={homeMeta.googleSiteVerification}
        ogTitle={homeMeta.title}
        ogDescription={homeMeta.description}
        ogImage={require('../assets/images/seo/cs.png')}
        ogUrl={settings.domain}
      />
      <Suspense fallback={<Loading />}>
        {/*<HomeSlider />*/}
        {/*<div className="home-slider-background">*/}
        <ClassicSlider/>
        {/*</div>*/}
        <div className="add-square-bg">
          <AboutSection />
        </div>
        <Service />
        <Product />
        <Testimonial />
        <div className="add-square-bg pt-20 md:pt-10">
          <Portfolio />
        </div>
        <div>
          <TechStack t={t}/>
        </div>
        <Contact />
        <div className="add-square-bg">
          <ClientsSection />
        </div>
        <SlideUp duration={2}>
          <div className="add-square-bg">
            <GetStartedBox />
          </div>
        </SlideUp>
      </Suspense>
    </div>
  );
};

export default Home;
